<template>
  <div class="graphic-typographic-three-content" id="identidade-visual-grafismos-tipografico-2" data-search-anchor>    
    <div class="description-graphic-typographic-three-title-icons-wrapper">
      <div class="graphic-typographic-three-icon-wrapper-first">
        <p class="graphic-typographic-three-description">
          {{ graphicTypographicThreeDescription1 }}
        </p>
      </div>

      <div class="graphic-typographic-three-icon-wrapper-sec">
        <IconCheck />
        <div>
          <p class="graphic-typographic-three-description-icon">
            {{ graphicTypographicThreeDescription2 }}
          </p>
        </div>
      </div>

      <div class="graphic-typographic-three-icon-wrapper">
        <IconCheck />
        <div>
          <p class="graphic-typographic-three-description-icon">
            {{ graphicTypographicThreeDescription3 }}
          </p>
        </div>
      </div>

      <div class="graphic-typographic-three-icon-wrapper-thr">
        <IconCheck />
        <div>
          <p class="graphic-typographic-three-description-icon">
            {{ graphicTypographicThreeDescription4 }}
          </p>
        </div>
      </div>
    </div>
    <div
      class="graphic-typographic-three-card-item"
      :style="{ backgroundImage: `url(${ImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import GraphicPageMixin from '@/mixins/graphic-page-mixin'
import { GraphicPageStore } from '@/store/visual-identity-page/graphic-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class GraphicsTypographicThreeSection extends Mixins(GraphicPageMixin) {
  graphicPageStore: PageStoreContract = getModule(GraphicPageStore, this.$store)

  get graphicTypographicThreeDescription1(): string {
    return this.getElementText(7, 1)
  }

  get graphicTypographicThreeDescription2(): string {
    return this.getElementText(7, 2)
  }

  get graphicTypographicThreeDescription3(): string {
    return this.getElementText(7, 3)
  }

  get graphicTypographicThreeDescription4(): string {
    return this.getElementText(7, 4)
  }

  get ImageSrc(): string {
    return this.getElementMedia(7, 5)
  }

  async getGraphicPage(): Promise<void> {
    await this.graphicPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.graphicPageStore.isLoading) {
      await this.getGraphicPage()
    }
  }
}
</script>

<style lang="scss">
.graphic-typographic-three-content {
  display: grid;
  max-width: 1032px;
}

.description-graphic-typographic-three-title-icons-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 51.2% 48.8%;
  margin-top: 2rem;
}

.graphic-typographic-three-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left; 

  width: 430px;
}

.graphic-typographic-three-icon-wrapper-first {
  display: flex;
}

.graphic-typographic-three-icon-wrapper-sec {
  display: flex;
  align-items: center;
}

.graphic-typographic-three-icon-wrapper {
  display: flex;
  align-items: center;
}

.graphic-typographic-three-icon-wrapper-thr {
  display: flex;
  align-items: center;
}

.graphic-typographic-three-card-item {
  position: relative;
  width: 1032px;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.graphic-typographic-three-description-icon {
  font-size: 16px;
  font-weight: bold;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 378px;
}
</style>
